import React, { Fragment } from 'react'

import PropTypes from 'prop-types'

import ActionCableMessaging from 'Pods/Shared/Messaging/ActionCableMessaging'

import JobActions from '../../Components/JobActions'

function JobMessaging({ conversationId, jobActions }) {
  return (
    <Fragment>
      <JobActions
        {...jobActions}
        showOffer
        asButtons
        isBordered
      />
      {(conversationId && conversationId !== 'null') ? (
        <ActionCableMessaging
          key={conversationId}
          conversationId={conversationId}
          conversationType="job_application"
          isJobConversation
        />
      ) : (
        <p>
          You need to apply to this job to start a conversation with the client.
        </p>
      )}
    </Fragment>
  )
}

JobMessaging.propTypes = {
  conversationId: PropTypes.string.isRequired,
  jobActions: PropTypes.object.isRequired,
}

export default JobMessaging
